// extracted by mini-css-extract-plugin
export default {"rating":"Az-z","numberOfStars":"Bz-z","count":"Cz-z","barGraphSpacing":"Dz-z","barGraph":"Ez-z"};